import {Skeleton, SxProps, Theme, TooltipProps, Typography} from "@mui/material"
import {FC, useRef, useState, useEffect, Fragment} from "react"
import {Tooltip} from "../../atoms"

interface TruncatedTextProps {
  text: string
  textSx?: SxProps<Theme>
  tooltipProps?: Omit<TooltipProps, "title" | "children">
  isLoading?: boolean
}

const TruncatedText: FC<TruncatedTextProps> = ({
  text,
  textSx,
  tooltipProps,
  isLoading,
}) => {
  const textRef = useRef<HTMLDivElement | null>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth)
    }
  }, [text])

  return (
    <Tooltip title={isTruncated ? text : ""} {...tooltipProps}>
      <Typography
        ref={textRef}
        fontSize="inherit"
        color="inherit"
        sx={{
          fontFamily: ["Open Sans", "Arial", "sans-serif"].join(","),
          display: "inline-block",
          // maxWidth: "80%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...textSx,
        }}
      >
        {isLoading ? (
          <Fragment>
            <Skeleton width="164px" variant="text" animation="wave" />
          </Fragment>
        ) : (
          text
        )}
      </Typography>
    </Tooltip>
  )
}

export default TruncatedText
